import { Box } from '@mui/material';
import { Viewer } from '@/components/Analysis/Viewer';
// import { FluidLayout } from '@/layouts';
import { StructureCheck } from '@/components/shared/StructureCheck';
import { useFetchCookies, useRouter } from '@/hooks';
import { PageLoader } from '@/components/shared/PageLoader';
import { AccessGuard } from '@/components/Analysis/shared/AccessGuard';
import styled from 'styled-components';
import { SCREENSHOT_MODES } from '@/constants';
import { useSetAtom } from 'jotai';
import * as state from '@/components/Analysis/state';
import { useEffect } from 'react';

const Main = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const AnalysisScreenshotPage = () => {
  const router = useRouter();
  const { inspection } = router.query;
  const cookiesFetched = useFetchCookies();

  const setScreenshotMode = useSetAtom(state.screenshotMode);

  const screenshotModeString = router.query.screenshotMode;
  const screenshotMode =
    (Array.isArray(screenshotModeString)
      ? undefined
      : SCREENSHOT_MODES.find((mode) => mode === screenshotModeString)) ?? 'normal';

  useEffect(() => {
    setScreenshotMode(screenshotMode);
  }, [setScreenshotMode, screenshotMode]);

  if (!inspection || Array.isArray(inspection)) {
    return <div>Please specify inspection id</div>;
  }
  if (!screenshotMode) {
    return <div>Please specify valid screenshot mode</div>;
  }

  if (!cookiesFetched) {
    return (
      <Box sx={{ position: 'relative', top: '25rem' }}>
        <PageLoader />
      </Box>
    );
  }

  return (
    <StructureCheck structureId={inspection}>
      <AccessGuard structureId={inspection} feature="viewer">
        <Main>
          {/* <FluidLayout variant="analysis"> */}
          <Viewer inspectionId={inspection} />
          {/* </FluidLayout> */}
        </Main>
      </AccessGuard>
    </StructureCheck>
  );
};
